import {useEffect} from 'react'
import {
  TrackingV2GetOrderQuery,
  TrackingV2GetOrderQueryVariables
} from '@data/__generated__/types.main'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useRouter} from 'next/router'

export default function useOrder() {
  const router = useRouter()
  const {orderId} = router.query
  const {order, loading, stopPolling} = useQuery<
    TrackingV2GetOrderQuery,
    TrackingV2GetOrderQueryVariables
  >({
    query: gql`
      query TrackingV2GetOrder($orderId: ID!) {
        order(orderId: $orderId) {
          _id
          menuId
          websiteId
          fullCode
          countryCode
          orderStatus
          deliveryType
          paymentStatus
          paymentType
          paymentGatewayUrl
          preparationReadyAt
          timeText
          dropOffType
          completedAt
          isScheduled
          isConfirmed
          specialRequirementsIds
          requiresDeliveryVerificationCode
          didTrack
          tableName
          email
          websiteCoinsGiven
          store {
            _id
            name
            hasDelayInAcceptingOrders
            address {
              location
              address
            }
          }
          address {
            _id
            address
            addressLine2
            location
          }
          delivery {
            _id
            status
            nearStoreAt
            nearClientAt
          }
          deliveryFee
          pendingPaymentRequests {
            _id
          }
          transaction {
            _id
            status
            publicMeta
            cardType
            cardId
            errorLabel
            totalPrice
          }
        }
      }
    `,
    variables: {orderId: Array.isArray(orderId) ? orderId[0] : orderId},
    fetchPolicy: 'cache-first',
    pollInterval: 1000 * 30,
    omit: !orderId
  })

  useEffect(() => {
    if (['done', 'cancelled'].includes(order?.orderStatus)) {
      stopPolling()
    }
  }, [order?.orderStatus, stopPolling])

  return {order, loading}
}
